module.exports = __webpack_public_path__ + "img/type-digital.ea0d501.png?v=1751624816731";